import React from 'react';
import ReactDOM from 'react-dom/client';

// CSS
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';


// Webvitals
import reportWebVitals from './reportWebVitals';

// Context
import { PortfolioProvider } from "../src/context/PortfolioContext";

// React Router
import { BrowserRouter, Route, Navigate, Routes } from 'react-router';

// Pages
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Portfolios from './pages/Portfolios';
import Quiz from './pages/Quiz';
import Learn from './pages/Learn';
import Glossary from './pages/Glossary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PortfolioProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolios" element={<Portfolios />} />
        <Route path="/portfolios/:id" element={<Portfolio />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/stock-market-glossary" element={<Glossary />} />


        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </BrowserRouter>
  </PortfolioProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
